import ExternalTenantMetadata from "./ExternalTenantMetadata";
import InternalTenantMetadata from "./InternalTenantMetadata";
export { ExternalTenantMetadata, InternalTenantMetadata };
